<style lang="scss">
  @import '../../../sass/_variables';

  #modal-domain-configuration {
    &.modal-no-header-no-footer {
      .modal-dialog {
        width: 800px;
        max-width: 800px;
      }

      .modal-body {
        .table {
          box-shadow: 0 5px 20px rgba(165, 131, 224, 0.15);

          thead th,
          thead td {
            height: 58px;
            font-weight: 500;
            letter-spacing: -0.15px;
          }
        }

        td {
          font-size: 0.8125rem;
          vertical-align: middle;
          overflow: hidden;
          overflow-wrap: break-word;
        }
      }
    }
  }
</style>

<template>
  <BModal
    id="modal-domain-configuration"
    modal-class="modal-no-header-no-footer"
    ref="modal-domain-configuration"
    hide-header="hide-header"
    hide-footer="hide-footer"
    @hidden="showCurrent = false"
  >
    <template slot="default">
      <button
        class="close"
        type="button"
        aria-label="Close"
        @click="$refs['modal-domain-configuration'].hide()"
      >
        <span aria-hidden="true">×</span>
      </button>
      <h4 class="modal-title align-items-center text-center mb-0">
        {{ __('Configuração de DNS') }}
      </h4>
      <div class="px-20px">
        <div v-if="domain.metadata">
          <h6 class="modal-title mb-20px px-0">
            {{ __('Registros DNS para o envio de e-mails') }}
          </h6>
          <div class="d-flex align-items-center justify-content-between">
            <p v-if="!showCurrent" class="form-text m-0">
              {{ __('Para validar seu domínio para o envio de e-mails, crie') }}
              <b>{{ __('todos') }}</b> {{ __('os registros abaixo') }}:
            </p>
            <p v-else class="form-text m-0">
              {{ __('Esses são seus registros DNS que estão atualmente configurados:') }}
            </p>
            <div class="d-flex align-items-center font-weight-bold">
              <span class="mr-2 text-salesflow-font-gray font-weight-bold">
                {{ showCurrent ? __('Valores atuais') : __('Valores novos') }}
              </span>
              <ToggleButton
                v-model="showCurrent"
                class="mb-0"
              />
            </div>
          </div>
          <table class="table table-striped table-borderless my-4">
            <thead>
              <tr>
                <th>{{ __('Tipo') }}</th>
                <th>{{ __('Hostname') }}</th>
                <th>{{ showCurrent ? __('Valor atual') : __('Adicione este valor') }}</th>
                <th v-if="showPriority">{{ __('Prioridade') }}</th>
                <th>{{ __('Válido') }}?</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(record, index) in domain.metadata[domain.provider].records">
                <td style="width: 82px; max-width: 82px;">
                  {{ record.record_type }}
                </td>
                <td style="width: 220px; max-width: 220px;">
                  {{ record.name }}
                </td>
                <td style="width: 224px; max-width: 224px;">
                  <div
                    @click="selectText(`${record.name}-${index}`)"
                    :id="`${record.name}-${index}`"
                  >
                    {{ showCurrent ? record.value : record.required_value }}
                  </div>
                </td>
                <td v-if="showPriority" style="width: 76px; max-width: 76px;">
                  {{ showCurrent ? record.priority : record.required_priority }}
                </td>
                <td
                  class="text-center"
                  style="width: 76px; max-width: 76px;"
                >
                  <Component :is="icon(record)" />
                </td>
              </tr>
            </tbody>
          </table>
          <p v-if="!showCurrent" class="form-text">
            {{ __('Você deve adicionar') }}
            <b>{{ __('todos') }}</b> {{ __('os registros acima para o envio de e-mails funcionar corretamente') }}.
          </p>
          <p
            class="form-text"
            v-if="domain.provider === 'mailgun' && !showCurrent"
          >
            {{ __('Caso já tenha um registro SPF (v=spf1...), adicione apenas') }}
            <code>include:mailgun.org</code> {{ __('antes de') }}
            <code>~all</code>
          </p>
          <p
            class="form-text"
            v-if="domain.provider === 'elastic' && !showCurrent"
          >
            {{ __('Caso já tenha um registro SPF (v=spf1...), adicione apenas') }}
            <code>include:salesflowcrmmail.com.br</code> {{ __('antes de') }}
            <code>~all</code>
          </p>
          <p
            class="form-text"
            v-if="domain.provider === 'ses' && !showCurrent"
          >
            {{ __('Caso já tenha um registro SPF (v=spf1...), adicione apenas') }}
            <code>include:amazonses.com</code> {{ __('antes de') }}
            <code>~all</code>
          </p>
          <div v-if="domain.metadata.page">
            <h6 class="modal-title mb-20px px-0">
              {{ __('Registros DNS para Landing Pages') }}
            </h6>
            <p v-if="!showCurrent" class="form-text">
              {{ __('Para publicar suas Landing Pages, crie') }}
              <b>{{ __('um dos registros') }}</b> {{ __('abaixo de acordo com o subdomínio desejado') }}.
            </p>
            <table class="table table-striped table-borderless my-4">
              <thead>
                <tr>
                  <th>{{ __('Tipo') }}</th>
                  <th>{{ __('Hostname') }}</th>
                  <th>{{ showCurrent ? __('Valor atual') : __("Adicione este valor") }}</th>
                  <th>{{ __('Válido') }}?</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="record in domain.metadata.page.records">
                  <td style="width: 82px; max-width: 82px;">
                    {{ record.record_type }}
                  </td>
                  <td style="width: 220px; max-width: 220px;">
                    {{ record.name }}
                  </td>
                  <td style="width: 340px; max-width: 340px;">
                    <div
                      @click="selectText(record.name)"
                      :id="record.name"
                    >
                      {{ showCurrent ? record.value : record.required_value }}
                    </div>
                  </td>
                  <td
                    class="text-center"
                    style="width: 76px; max-width: 76px;"
                  >
                    <Component :is="icon(record)" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="domain.metadata[domain.provider].optional_records && domain.metadata[domain.provider].optional_records.length > 0">
            <h6 class="modal-title mb-20px px-0">
              {{ __('Registros DNS opcionais') }}
            </h6>
            <p v-if="!showCurrent" class="form-text">
              {{ __('Adicione os registros abaixo') }}
              <b>{{ __('somente se não existir') }}</b> {{ __('nenhum registro MX em seu domínio') }}.
            </p>
            <p v-if="!showCurrent" class="form-text">
              {{ __('Alguns provedores de e-mail só aceitam e-mails de domínios que possuem registros MX') }}.
            </p>
            <table class="table table-striped table-borderless my-4">
              <thead>
                <tr>
                  <th>{{ __('Tipo') }}</th>
                  <th>{{ __('Hostname') }}</th>
                  <th>{{ showCurrent ? __('Valor atual') : __('Adicione este valor') }}</th>
                  <th>{{ __('Prioridade') }}</th>
                  <th>{{ __('Válido') }}?</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="record in domain.metadata[domain.provider].optional_records">
                  <td style="width: 82px; max-width: 82px;">
                    {{ record.record_type }}
                  </td>
                  <td style="width: 220px; max-width: 220px;">
                    {{ record.name }}
                  </td>
                  <td style="width: 242px; max-width: 242px;">
                    <div
                      @click="selectText(record.name)"
                      :id="record.name"
                    >
                      {{ showCurrent ? record.value : record.required_value }}
                    </div>
                  </td>
                  <td
                    class="text-center"
                    style="width: 98px; max-width: 98px;"
                  >
                    {{ record.priority }}
                  </td>
                  <td
                    class="text-center"
                    style="width: 76px; max-width: 76px;"
                  >
                    <Component :is="icon(record)" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="form-text">
            {{ __('Após alterar sua configuração de DNS, aguarde a propagação e verifique novamente') }}.
          </p>
        </div>
        <div class="modal-footer default-modal-footer">
          <div class="col-12">
            <div class="row text-center">
              <div class="col-12">
                <button
                  class="btn btn-primary f-w-500"
                  type="button"
                  @click="verify(domain)"
                  :disabled="verifying"
                >
                  {{ __('Verificar novamente') }}
                </button>
              </div>
            </div>
            <div class="row text-center">
              <div class="col-12">
                <button
                  class="btn btn-cancel f-w-500"
                  type="button"
                  aria-label="Close"
                  @click="$refs['modal-domain-configuration'].hide()"
                >
                  <u>{{ __('Fechar') }}</u>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  mounted () {
    Bus.$on('verifyDomain', (domain) => this.verify(domain));

    Bus.$on('showDomainRecords', (domain) => {
      if (
        domain.metadata
          && domain.metadata[domain.provider]
          && domain.metadata[domain.provider].records
      ) {
        this.domain = domain;

        this.$refs['modal-domain-configuration'].show();
      } else {
        this.verify(domain, true);
      }
    });

    Bus.$on('verifyingDomain', (bool) => this.verifying = bool);
  },

  data () {
    return {
      domain: {},
      verifying: false,
      showCurrent: false,
    };
  },

  computed: {
    showPriority() {
      return this.domain.provider == 'ses';
    },
  },

  methods: {
    verify (domain, verifiedModal = false) {
      this.domain = domain;

      if (this.verifying) {
        return this.verifying;
      }

      this.$refs['modal-domain-configuration'].hide();

      Bus.$emit('verifyingDomain', domain.identifier);

      this.$http.post('/settings/domain/dns', { domain: domain.identifier })
        .then(({ data }) => {
          this.domain = data;

          if (this.domain.verified) {
            Bus.$emit('domainVerified', this.domain);

            if (verifiedModal) {
              this.$refs['modal-domain-configuration'].show();
            }
          } else {
            this.$refs['modal-domain-configuration'].show();
          }

          Bus.$emit('domainUpdated', this.domain);
        })
        .catch(() => Alert.error(this.__('Erro ao verificar seu domínio, tente novamente mais tarde.')))
        .finally(() => Bus.$emit('verifyingDomain', false));
    },

    selectText (id) {
      const node = document.getElementById(id);

      if (document.selection) {
        var range = document.body.createTextRange();
        range.moveToElementText(node);
        range.select();
      } else if (window.getSelection) {
        var range = document.createRange();
        range.selectNodeContents(node);

        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },

    icon (record) {
      if (this.showCurrent && (record.valid === 'valid' || record.valid === true)) {
        return 'IconCheck';
      }

      if (record.valid_required_value) {
        return 'IconCheck';
      }

      return 'IconTimes';
    },
  },
};
</script>
